<template>
  <div>
    <b-modal
      ref="mdlAtendimentoFormulario"
      :title="title"
      :ok-title="salvando ? 'Salvando...' : 'Salvar'"
      :ok-disabled="salvando"
      cancel-title="Cancelar"
      size="lg"
      @ok.prevent="salvar"
      @hidden="limpar"
      @shown="validacao"
      centered
      class="modal-tabs"
      scrollable
    >
      <form ref="frmAtendimentoFormulario">
        <b-tabs content-class="p-7">
          <!-- Tab Paciente -->
          <b-tab title="Dados do Paciente" active>
            <b-row>
              <b-col cols="4" v-if="!formulario.id">
                <b-form-group label="CPF:" label-for="atendimento-cpf">
                  <b-input-group>
                    <b-form-input
                      id="atendimento-cpf"
                      name="cpf"
                      v-model="formulario.cpf"
                      size="sm"
                      data-inputmask="'alias': 'cpf'"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        @click="buscarPaciente"
                        variant="primary"
                      >
                        <b-icon-search></b-icon-search>
                      </b-button>
                      <b-button
                        size="sm"
                        @click="cadastrarPaciente"
                        variant="success"
                      >
                        <b-icon-plus></b-icon-plus>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Nome:" label-for="atendimento-nome">
                  <b-form-input
                    id="atendimento-nome"
                    name="nome"
                    v-model="formulario.nome"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Endereço:"
                  label-for="atendimento-endereco"
                >
                  <b-form-input
                    id="atendimento-endereco"
                    name="endereco"
                    v-model="formulario.endereco"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="2">
                <b-form-group
                  label="Número:"
                  label-for="atendimento-numero-endereco"
                >
                  <b-form-input
                    id="atendimento-numero-endereco"
                    name="numero_endereco"
                    v-model="formulario.numero_endereco"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Bairro:" label-for="atendimento-bairro">
                  <b-form-input
                    id="atendimento-bairro"
                    name="bairro"
                    v-model="formulario.bairro"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Complemento:"
                  label-for="atendimento-complemento"
                >
                  <b-form-input
                    id="atendimento-complemento"
                    name="complemento"
                    v-model="formulario.complemento"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Estado:" label-for="atendimento-estado">
                  <b-form-input
                    id="atendimento-estado"
                    name="estado"
                    v-model="formulario.estado"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Cidade:" label-for="atendimento-cidade">
                  <b-form-input
                    id="atendimento-cidade"
                    name="cidade"
                    v-model="formulario.cidade"
                    size="sm"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Data de nascimento:"
                  label-for="atendimento-data-nascimento"
                >
                  <b-form-input
                    id="atendimento-data-nascimento"
                    name="data_nascimento"
                    v-model="formulario.data_nascimento"
                    size="sm"
                    type="date"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Cartão do SUS:"
                  label-for="atendimento-cartao-sus"
                >
                  <b-form-input
                    id="atendimento-cartao-sus"
                    name="cartao_sus"
                    v-model="formulario.cartao_sus"
                    size="sm"
                    data-inputmask="'alias': 'cartao_sus'"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Cor:" label-for="atendimento-cor">
                  <b-form-input
                    id="atendimento-cor"
                    name="cartao_sus"
                    v-model="formulario.cor"
                    size="sm"
                    plaintext
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Telefone:"
                  label-for="atendimento-telefone"
                >
                  <b-form-input
                    id="atendimento-telefone"
                    name="telefone"
                    v-model="formulario.telefone"
                    size="sm"
                    data-inputmask="'alias': 'telefone'"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Celular:" label-for="atendimento-celular">
                  <b-form-input
                    id="atendimento-celular"
                    name="celular"
                    v-model="formulario.celular"
                    size="sm"
                    data-inputmask="'alias': 'celular'"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Email:" label-for="atendimento-email">
                  <b-form-input
                    id="atendimento-email"
                    name="email"
                    v-model="formulario.email"
                    size="sm"
                    data-inputmask="'alias': 'email'"
                    plaintext
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- Fim Tab Paciente -->

          <!-- Tab Anamnese -->
          <b-tab title="Anamnese">
            <b-row>
              <b-col>
                <b-form-group
                  label="Local de atendimento:"
                  label-for="atendimento-local-atendimento"
                >
                  <b-form-input
                    id="atendimento-local-atendimento"
                    name="local_atendimento"
                    v-model="formulario.local_atendimento"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Procedência do paciente:"
                  label-for="atendimento-procedencia-paciente"
                >
                  <b-form-radio-group
                    id="atendimento-procedencia-paciente"
                    name="procedencia-paciente"
                    v-model="formulario.procedencia_paciente"
                    :options="[
                      { text: 'Aluno', value: 'A' },
                      { text: 'Professor', value: 'P' },
                      { text: 'Diretor', value: 'D' },
                      { text: 'Funcionário', value: 'F' },
                      { text: 'Externo', value: 'E' },
                    ]"
                    size="sm"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-if="formulario.procedencia_paciente !== 'E'">
                <b-form-group
                  label="Nome da Instituição:"
                  label-for="atendimento-nome-instituicao"
                >
                  <b-form-input
                    id="atendimento-nome-instituicao"
                    name="nome_instituicao"
                    v-model="formulario.nome_instituicao"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Pressão Arterial (PA):"
                  label-for="atendimento-pressao-arterial"
                >
                  <b-form-input
                    id="atendimento-pressao-arterial"
                    name="pressao_arterial"
                    v-model="formulario.pressao_arterial"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Temperatura (T℃):"
                  label-for="atendimento-temperatura"
                >
                  <b-form-input
                    id="atendimento-temperatura"
                    name="temperatura"
                    v-model="formulario.temperatura"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Frequência Cardiaca (FC):"
                  label-for="atendimento-frequencia-cardiaca"
                >
                  <b-form-input
                    id="atendimento-frequencia-cardiaca"
                    name="frequencia_cardiaca"
                    v-model="formulario.frequencia_cardiaca"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Frequência Respiratória (FR):"
                  label-for="atendimento-frequencia-respiratoria"
                >
                  <b-form-input
                    id="atendimento-frequencia-respiratoria"
                    name="frequencia_respiratoria"
                    v-model="formulario.frequencia_respiratoria"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Glicemia:"
                  label-for="atendimento-glicemia"
                >
                  <b-form-input
                    id="atendimento-glicemia"
                    name="glicemia"
                    v-model="formulario.glicemia"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Gestante:"
                  label-for="atendimento-gestante"
                >
                  <b-form-select
                    id="atendimento-gestante"
                    name="gestante"
                    v-model="formulario.gestante"
                    size="sm"
                  >
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <!-- Fim Tab Anamnese -->

          <!-- Tab Comorbidades -->
          <b-tab title="Comorbidades">
            <!-- Alergias: Input option with Sim or Não -->
            <b-form-group
              label="Já sentiu dor de dente em algum momento da vida:"
              label-for="atendimento-historico-dor-dente"
            >
              <b-form-radio-group
                id="atendimento-historico-dor-dente"
                name="historico_dor_dente"
                v-model="formulario.historico_dor_dente"
                :options="[
                  {
                    text: 'Sim',
                    value: 'S',
                  },
                  { text: 'Não', value: 'N' },
                ]"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group label="Alergias:" label-for="atendimento-alergias">
              <b-form-radio-group
                id="atendimento-alergias"
                name="alergias"
                v-model="formulario.alergias"
                :options="[
                  { text: 'Sim', value: 'S' },
                  { text: 'Não', value: 'N' },
                ]"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              label="Descrever as alergias caso existam:"
              label-for="atendimento-descricao-alergias"
            >
              <b-form-input
                id="atendimento-descricao-alergias"
                name="descricao_alergias"
                v-model="formulario.descricao_alergias"
                size="sm"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Tem histórico de trombofilias ou coagulopatias:"
              label-for="atendimento-trombofilia-coagulopatia"
            >
              <b-form-radio-group
                id="atendimento-trombofilia-coagulopatia"
                name="trombofilia_coagulopatia"
                v-model="formulario.trombofilia_coagulopatia"
                :options="[
                  { text: 'Sim', value: 'S' },
                  { text: 'Não', value: 'N' },
                ]"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              label="Tem histórico de complicação em tratamento odontológico:"
              label-for="atendimento-historico-complicacao"
            >
              <b-form-radio-group
                id="atendimento-historico-complicacao"
                name="historico_complicacao"
                v-model="formulario.historico_complicacao"
                :options="[
                  { text: 'Sim', value: 'S' },
                  { text: 'Não', value: 'N' },
                ]"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              label="Descrever as complicações caso existam:"
              label-for="atendimento-descricao-complicacao"
            >
              <b-form-input
                id="atendimento-descricao-complicacao"
                name="descricao_complicacao"
                v-model="formulario.descricao_complicacao"
                size="sm"
              ></b-form-input>
            </b-form-group>
          </b-tab>
          <!-- Fim Tab Comorbidades -->

          <!-- Tab Procedimentos -->
          <b-tab title="Procedimentos" v-if="formulario.status_id === 'F'">
            <template v-for="procedimento in formulario.procedimentos">
              <b-form-group
                :key="procedimento.id"
                :label="procedimento.nome"
                v-if="
                  Number(formulario.idade) >=
                    Number(procedimento.idade_minima) &&
                  Number(formulario.idade) <= Number(procedimento.idade_maxima)
                "
              >
                <b-form-radio-group
                  v-model="procedimento.quantidade"
                  :options="[
                    { text: '0', value: 0 },
                    { text: '1', value: 1 },
                    { text: '2', value: 2 },
                    { text: '3', value: 3 },
                    { text: '4', value: 4 },
                    { text: '5', value: 5 },
                    { text: '6', value: 6 },
                    { text: '7', value: 7 },
                    { text: '8', value: 8 },
                    { text: '9', value: 9 },
                    { text: '10', value: 10 },
                  ]"
                  size="lg"
                ></b-form-radio-group>
              </b-form-group>
            </template>
          </b-tab>
          <!-- Fim Tab Procedimentos -->

          <!-- Tab Diagnóstico -->
          <b-tab title="Dignóstico" v-if="formulario.status_id === 'F'">
            <b-form-group
              label="Diagnóstico"
              label-for="atendimento-diagnostico"
            >
              <b-form-textarea
                id="atendimento-diagnostico"
                name="diagnostico"
                v-model="formulario.diagnostico"
                size="sm"
                rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-tab>

          <b-tab
            title="Outros"
            v-if="formulario.status_id === 'A' && temFuncao('Administrador')"
          >
            <b-col col md="6">
              <b-form-group label="Unidade:" label-for="atendimento-unidade">
                <b-form-select
                  id="atendimento-unidade"
                  name="unidade"
                  v-model="formulario.unidade_id"
                  :options="unidades"
                  value-field="id"
                  text-field="nome"
                  size="sm"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- Selecione uma unidade --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-tab>
        </b-tabs>
      </form>
    </b-modal>

    <paciente-formulario
      ref="mdlPacienteFormulario"
      @paciente-cadastrado="pacienteCadastrado"
    ></paciente-formulario>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AtendimentoService from "@/core/services/atendimento.service";
import PacienteService from "@/core/services/paciente.service";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import Swal from "sweetalert2";
import Inputmask from "@/core/plugins/inputmask";

import PacienteFormulario from "../pacientes/PacienteFormulario.vue";
import moment from "@/core/plugins/moment";

export default {
  name: "atendimento-formulario",

  components: { PacienteFormulario },

  props: {
    procedimentos: {
      type: Array,
      required: true,
    },
    unidades: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      salvando: false,
      formulario: {
        id: null,
        paciente_id: null,
        nome: "",
        cpf: "",
        endereco: "",
        numero_endereco: "",
        complemento_endereco: "",
        bairro: "",
        cidade: "",
        estado: "",
        data_nascimento: "",
        cartao_sus: "",
        cor: "",
        telefone: "",
        celular: "",
        email: "",
        idade: "",
        local_atendimento: "",
        procedencia_paciente: "A",
        nome_instituicao: "",
        pressao_arterial: "",
        temperatura: "",
        frequencia_cardiaca: "",
        frequencia_respiratoria: "",
        glicemia: "",
        historico_dor_dente: "",
        alergias: "",
        descricao_alergias: "",
        trombofilia_coagulopatia: "",
        historico_complicacao: "",
        descricao_complicacao: "",
        diagnostico: "",
        gestante: "N",
        status_id: "A",
        unidade_id: null,
        procedimentos: [],
      },
    };
  },

  methods: {
    exibirModal(atendimento) {
      if (atendimento) {
        this.formulario.id = atendimento.id;
        this.formulario.paciente_id = atendimento.paciente_id;
        this.formulario.nome = atendimento.paciente.nome;
        this.formulario.cpf = atendimento.paciente.cpf;
        this.formulario.endereco = atendimento.paciente.endereco;
        this.formulario.numero_endereco = atendimento.paciente.numero_endereco;
        this.formulario.bairro = atendimento.paciente.bairro;
        this.formulario.complemento = atendimento.paciente.complemento;
        this.formulario.estado = atendimento.paciente.cidade.estado.nome;
        this.formulario.cidade = atendimento.paciente.cidade.nome;
        this.formulario.data_nascimento = atendimento.paciente.data_nascimento;
        this.formulario.cartao_sus = atendimento.paciente.cartao_sus;
        this.formulario.cor = this.obterCor(atendimento.paciente.cor);
        this.formulario.telefone = atendimento.paciente.telefone;
        this.formulario.celular = atendimento.paciente.celular;
        this.formulario.email = atendimento.paciente.email;
        this.formulario.idade = atendimento.idade;
        this.formulario.local_atendimento = atendimento.local_atendimento;
        this.formulario.procedencia_paciente = atendimento.procedencia_paciente;
        this.formulario.nome_instituicao = atendimento.nome_instituicao;
        this.formulario.pressao_arterial = atendimento.pressao_arterial;
        this.formulario.temperatura = atendimento.temperatura;
        this.formulario.frequencia_cardiaca = atendimento.frequencia_cardiaca;
        this.formulario.frequencia_respiratoria =
          atendimento.frequencia_respiratoria;
        this.formulario.glicemia = atendimento.glicemia;
        this.formulario.historico_dor_dente = atendimento.historico_dor_dente;
        this.formulario.alergias = atendimento.alergias;
        this.formulario.descricao_alergias = atendimento.descricao_alergias;
        this.formulario.trombofilia_coagulopatia =
          atendimento.trombofilia_coagulopatia;
        this.formulario.historico_complicacao =
          atendimento.historico_complicacao;
        this.formulario.descricao_complicacao =
          atendimento.descricao_complicacao;
        this.formulario.diagnostico = atendimento.diagnostico;
        this.formulario.gestante = atendimento.gestante;
        this.formulario.status_id = atendimento.status_id;
        this.formulario.unidade_id = atendimento.unidade_id;
        this.formulario.procedimentos = this.procedimentos.map(
          (procedimento) => {
            const atendimentoProcedimento = atendimento.procedimentos.find(
              (p) => p.procedimento_id === procedimento.id
            );

            return {
              id: atendimentoProcedimento ? atendimentoProcedimento.id : null,
              procedimento_id: procedimento.id,
              nome: procedimento.nome,
              quantidade: atendimentoProcedimento
                ? atendimentoProcedimento.quantidade
                : 0,
              idade_minima: procedimento.idade_minima,
              idade_maxima: procedimento.idade_maxima,
            };
          }
        );
      }

      this.$refs.mdlAtendimentoFormulario.show();
    },

    async salvar() {
      if (this.salvando) {
        return;
      }

      this.salvando = true;

      try {
        const status = await this.fv.validate();

        if (status !== "Valid") {
          return;
        }

        let formulario = {
          ...this.formulario,
          procedimentos: Object.values(this.formulario.procedimentos),
        };

        await AtendimentoService.salvar(formulario);

        this.$emit("atualizar");
        this.$refs.mdlAtendimentoFormulario.hide();

        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Atendimento salvo com sucesso.",
        });
      } catch (error) {
        if (error.response?.status === 422) {
          Object.entries(error.response.data.errors).forEach(([key, value]) => {
            this.fv
              .updateValidatorOption(key, "blank", "message", value[0])
              .updateFieldStatus(key, "Invalid", "blank");
          });
        }
      } finally {
        this.salvando = false;
      }
    },

    validacao() {
      const frmAtendimentoFormulario = this.$refs.frmAtendimentoFormulario;
      Inputmask().mask(
        frmAtendimentoFormulario.querySelectorAll("[data-inputmask]")
      );

      this.fv = formValidation(frmAtendimentoFormulario, {
        fields: {
          pressao_arterial: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          temperatura: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          frequencia_cardiaca: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          frequencia_respiratoria: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          glicemia: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          historico_dor_dente: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          alergias: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          trombofilia_coagulopatia: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          historico_complicacao: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap(),
        },
      });

      if (this.administrador) {
        this.fv.addField("unidade", {
          validators: {
            notEmpty: {
              message: "Preenchimento obrigatório.",
            },
            blank: {},
          },
        });
      }
    },

    limpar() {
      this.formulario.id = null;
      this.formulario.paciente_id = null;
      this.formulario.nome = "";
      this.formulario.cpf = "";
      this.formulario.endereco = "";
      this.formulario.numero_endereco = "";
      this.formulario.bairro = "";
      this.formulario.complemento = "";
      this.formulario.estado = "";
      this.formulario.cidade = "";
      this.formulario.data_nascimento = "";
      this.formulario.cartao_sus = "";
      this.formulario.cor = "";
      this.formulario.telefone = "";
      this.formulario.celular = "";
      this.formulario.email = "";
      this.formulario.idade = "";
      this.formulario.local_atendimento = "";
      this.formulario.procedencia_paciente = "A";
      this.formulario.nome_instituicao = "";
      this.formulario.pressao_arterial = "";
      this.formulario.temperatura = "";
      this.formulario.frequencia_cardiaca = "";
      this.formulario.frequencia_respiratoria = "";
      this.formulario.glicemia = "";
      this.formulario.historico_dor_dente = "";
      this.formulario.alergias = "";
      this.formulario.descricao_alergias = "";
      this.formulario.trombofilia_coagulopatia = "";
      this.formulario.historico_complicacao = "";
      this.formulario.descricao_complicacao = "";
      this.formulario.diagnostico = "";
      this.formulario.gestante = "N";
      this.formulario.status_id = "A";
      this.formulario.unidade_id = null;
      this.formulario.procedimentos = [];
    },

    async buscarPaciente() {
      const cpf = this.formulario.cpf.replace(/\D/g, "");

      if (!cpf || cpf.length < 11) {
        Swal.fire({
          icon: "info",
          title: "Mensagem!",
          text: "Informe um CPF válido para buscar.",
        });

        return;
      }

      await PacienteService.getPaciente(this.formulario.cpf).then(
        ({ data }) => {
          if (Object.keys(data).length !== 0) {
            this.formulario.paciente_id = data.id;
            this.formulario.nome = data.nome;
            this.formulario.endereco = data.endereco;
            this.formulario.numero_endereco = data.numero_endereco;
            this.formulario.bairro = data.bairro;
            this.formulario.complemento = data.complemento;
            this.formulario.estado = data.estado.nome;
            this.formulario.cidade = data.cidade.nome;
            this.formulario.data_nascimento = data.data_nascimento;

            const nascimento = moment(data.data_nascimento);
            const hoje = moment();
            const idade = hoje.diff(nascimento, "years");

            this.formulario.idade = idade;

            this.formulario.cartao_sus = data.cartao_sus;
            this.formulario.cor = this.obterCor(data.cor);
            this.formulario.telefone = data.telefone;
            this.formulario.celular = data.celular;
            this.formulario.email = data.email;
          } else {
            this.formulario.paciente_id = "";
            this.formulario.nome = "";
            this.formulario.endereco = "";
            this.formulario.numero_endereco = "";
            this.formulario.bairro = "";
            this.formulario.complemento = "";
            this.formulario.estado = "";
            this.formulario.cidade = "";
            this.formulario.data_nascimento = "";
            this.formulario.cartao_sus = "";
            this.formulario.cor = "";
            this.formulario.telefone = "";
            this.formulario.celular = "";
            this.formulario.email = "";
            this.formulario.idade = "";

            Swal.fire({
              icon: "warning",
              title: "Alerta!",
              text: "Não existe cadastro para o CPF informado.",
            });
          }
        }
      );
    },

    cadastrarPaciente() {
      this.$refs.mdlPacienteFormulario.exibirModal();
    },

    pacienteCadastrado(paciente) {
      this.formulario.paciente_id = paciente.id;
      this.formulario.nome = paciente.nome;
      this.formulario.cpf = paciente.cpf;
      this.formulario.endereco = paciente.endereco;
      this.formulario.numero_endereco = paciente.numero_endereco;
      this.formulario.bairro = paciente.bairro;
      this.formulario.complemento = paciente.complemento;
      this.formulario.estado = paciente.estado.nome;
      this.formulario.cidade = paciente.cidade.nome;
      this.formulario.data_nascimento = paciente.data_nascimento;
      this.formulario.cartao_sus = paciente.cartao_sus;
      this.formulario.cor = this.obterCor(paciente.cor);
      this.formulario.telefone = paciente.telefone;
      this.formulario.celular = paciente.celular;
      this.formulario.email = paciente.email;

      const nascimento = moment(paciente.data_nascimento);
      const hoje = moment();
      const idade = hoje.diff(nascimento, "years");

      this.formulario.idade = idade;

      this.$refs.mdlPacienteFormulario.hide();
    },

    obterCor(cor) {
      switch (cor) {
        case "branco":
          return "Branco";
        case "negro":
          return "Negro";
        case "pardo":
          return "Pardo";
        case "amarelo":
          return "Amarelo";
        case "indigena":
          return "Indígena";
        default:
          return "";
      }
    },
  },

  computed: {
    ...mapGetters(["temFuncao"]),

    administrador() {
      return this.temFuncao("Administrador");
    },

    title() {
      return this.formulario.id ? "Editar Atendimento" : "Novo Atendimento";
    },
  },

  beforeDestroy: function () {
    if (this.fv) {
      this.fv.destroy();
    }
  },
};
</script>

<style scoped>
/deep/ .custom-checkbox .custom-control-label::before {
  top: 0.1rem !important;
}
/deep/ .custom-checkbox .custom-control-label::after {
  top: 0.1rem !important;
}
/deep/ .modal-body {
  padding: 0 !important;
}
/deep/ .modal-header {
  border-bottom: 0 !important;
}
/deep/ .form-group .b-custom-control-lg label {
  padding-top: 0.25rem !important;
}
</style>
